import { Component, inject, signal, computed, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormationsService } from '../../../../../../services/formations.service';
import { Router } from '@angular/router';




@Component({
  selector: 'app-manage-formations-table',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, ConfirmDialogModule, ToastModule],
  providers: [ConfirmationService, MessageService],
  templateUrl: './manage-formations-table.component.html',
  styleUrls: ['./manage-formations-table.component.scss']
})
export class ManageFormationsTableComponent implements OnInit {
  private formationsService = inject(FormationsService);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);
  private router = inject(Router);
  formations = signal<any[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  // ✅ pas de created_at dans ton model => tri simple par id desc
  sortedFormations = computed(() =>
    this.formations().slice().sort((a: any, b: any) => (b.id ?? 0) - (a.id ?? 0))
  );

  ngOnInit() {
    this.load();
  }

  load() {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.formationsService.getAdminFormations().subscribe({
      next: (data) => {
        this.formations.set(data ?? []);
        this.isLoading.set(false);
      },
      error: () => {
        this.errorMessage.set('Impossible de charger les formations.');
        this.isLoading.set(false);
      }
    });
  }

  // ✅ compile + on branchera l'edit après
  editFormation(formation: any) {
    this.router.navigate(['/admin/formations', formation.id, 'edit']);
  }

  // ✅ compile + confirmation + on branchera le delete après
  deleteFormation(formation :any, event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Voulez-vous vraiment supprimer cette formation ?',
      header: 'Confirmation',
      icon: 'pi pi-info-circle',
      rejectLabel: 'Annuler',
      acceptLabel: 'Supprimer',
      accept: () => {
        // si backend DELETE pas prêt, on laisse juste un log
        console.log('delete formation', formation);
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Delete non branché pour le moment' });
      }
    });
  }
}
